import { createAction, createReducer, on, props } from '@ngrx/store';
import { SessionInfo } from '../api/UserPrefs-dto';
import * as lodash from 'lodash';

export const SET_USER_TYPE = 'SET_USER';
export const SET_USER = createAction(SET_USER_TYPE, props<{ sessionInfo: SessionInfo, avoidPersistence?: boolean }>());
// export const SET_USER = createAction(SET_USER_TYPE, props<{ sessionInfo: SessionInfo }>());
export const DELETE_USER_TYPE = 'DELETE_USER';
export const DELETE_USER = createAction(DELETE_USER_TYPE, props<{ avoidPersistence?: boolean }>());
// export const DELETE_USER = createAction(DELETE_USER_TYPE);
export const SET_ACCESSMODE = createAction('SET_ACCESSMODE', props<{ modoAcceso: boolean, avoidPersistence?: boolean }>());
export const SET_USEREXTRAPARAM = createAction('SET_USEREXTRAPARAM', props<{ key: string, value: string, avoidPersistence?: boolean }>());
export const REMOVE_USEREXTRAPARAM = createAction('REMOVE_USEREXTRAPARAM', props<{ key: string, avoidPersistence?: boolean }>());
export const REMOVE_ALLUSEREXTRAPARAMS = createAction('REMOVE_ALLUSEREXTRAPARAMS', props<{ avoidPersistence?: boolean }>());

const initialState = new SessionInfo();

const _userReducer = createReducer(
  initialState,
  on(DELETE_USER, () => initialState),
  on(SET_USER, (state, { sessionInfo }) => {
    if (sessionInfo && state) {
      // Mantenemos los datos de modoAcceso y extraParams
      sessionInfo.modoAcceso = state.modoAcceso;
      sessionInfo.extraParams = state.extraParams;
    }
    return (sessionInfo) ? sessionInfo : state;
  }),
  on(SET_ACCESSMODE, (state, { modoAcceso }) => {
    // Accion para establecer el modo de acceso.
    state.modoAcceso = modoAcceso;
    return state;
  }),
  on(SET_USEREXTRAPARAM, (state, { key, value }) => {
    const newState = lodash.clone(state);
    newState.extraParams[key] = value;
    return newState;
  }),
  on(REMOVE_USEREXTRAPARAM, (state, { key }) => {
    delete state.extraParams[key];
    return state;
  }),
  on(REMOVE_ALLUSEREXTRAPARAMS, (state, { avoidPersistence: boolean }) => {
    delete state.extraParams;
    return state;
  })
);

export function userReducer(state, action) {
  return _userReducer(state, action);
}
